import { render, staticRenderFns } from "./Datagraph2.vue?vue&type=template&id=29bb1606&scoped=true"
import script from "./Datagraph2.vue?vue&type=script&lang=js"
export * from "./Datagraph2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bb1606",
  null
  
)

export default component.exports